export const faqs = [
  {
    q: "How will I receive the materials?",
    a: [
      "The collection is delivered digitally.",
      "The exact access instructions and file formats are provided on the checkout page.",
    ],
  },
  {
    q: "What exactly is included?",
    a: [
      "Your purchase includes six educational volumes and five specialized bonuses.",
      "The collection covers patient assessment, facial anatomy, complication awareness, vascular warning signs, injectable treatment complications, and clinical documentation.",
      "The bonuses include educational case studies, assessment worksheets, a warning-sign reference atlas, follow-up documentation templates, and a clinical safety audit workbook.",
    ],
  },
  {
    q: "Is this a physical product?",
    a: [
      "No. FACIAL AESTHETICS CLINICAL ROADMAP™ is a digital educational product.",
      "No physical books or printed materials are included unless explicitly stated on the checkout page.",
    ],
  },
  {
    q: "Who is this collection for?",
    a: [
      "The collection is intended for appropriately qualified facial aesthetic professionals who want to organize their educational references and review relevant clinical concepts.",
      "It may be useful to eligible medical professionals and other practitioners working within the scope of their qualifications and applicable regulations.",
      "It is not intended to qualify untrained individuals to perform clinical procedures.",
    ],
  },
  {
    q: "Is this a complete clinical training course?",
    a: [
      "No. This is an educational reference collection, not a substitute for formal education, supervised training, practical instruction, or professional qualifications.",
      "Its purpose is to organize educational information and provide reference materials for continuing professional learning.",
    ],
  },
  {
    q: "Does this replace clinical judgment or emergency protocols?",
    a: [
      "No.",
      "Clinical decisions must be made by appropriately qualified professionals based on individual patient circumstances, current evidence, applicable regulations, and established clinical protocols.",
      "The collection does not replace emergency training, specialist assessment, or individualized clinical management.",
    ],
  },
  {
    q: "Can I use the materials in any country?",
    a: [
      "The educational concepts may be relevant to professionals in different countries, but professional requirements, regulations, and clinical guidelines vary.",
      "You are responsible for adapting any templates or checklists to your professional scope and local requirements.",
    ],
  },
  {
    q: "Can I download the files?",
    a: [
      "The collection provides digital access. File formats and download details are shown on the checkout page.",
    ],
  },
  {
    q: "Is this a recurring subscription?",
    a: [
      "No. The listed price is a one-time payment of $27 USD.",
      "There is no recurring subscription for this offer.",
    ],
  },
  {
    q: "What if I decide the collection isn’t right for me?",
    a: [
      "Please review the refund terms displayed on the checkout page before purchasing.",
    ],
  },
  {
    q: "Does the collection guarantee better clinical outcomes?",
    a: [
      "No. The collection is intended for professional education and reference.",
      "It does not guarantee clinical outcomes, eliminate complications, or replace individualized assessment and professional judgment.",
    ],
  },
];
